import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import FileSystem from "../views/FileSystem.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/test",
    name: "Test",
    component: FileSystem
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
